<div class="system-message-stack" *ngIf="isAuthenticated && messages?.length">
  <div
    class="system-message"
    *ngFor="let message of messages"
    [ngClass]="message?.severity">
    <div class="icon" [ngClass]="message?.severity">
      <ng-container [ngSwitch]="message?.severity">
        <span *ngSwitchCase="'warning'">!</span>
        <span *ngSwitchCase="'critical'">!</span>
        <span *ngSwitchDefault>i</span>
      </ng-container>
    </div>
    <div class="content">
      <div class="title">{{ message?.title }}</div>
      <div class="text">{{ message?.message }}</div>
    </div>
    <button class="close-btn" type="button" aria-label="Schließen" (click)="close(message.id)">&times;</button>
  </div>
</div>
